import testUser from '../../mocks/testUser';
import {
  movieReportEngagement,
  movieReportViewership,
  movieReportAnticipation,
  movieReport,
  movieSummaryReport,
  movieReportAffinity
} from '../../config/filters';

const moviesConfig = {
  testUser,
  MOVIE_REPORT_FILTERS: {
    movieReportEngagement,
    movieReportViewership,
    movieReportAnticipation,
    movieReportAffinity,
    movieReport,
    memeListQuery: {
      id: 'memesList',
      fields: ['screencapId']
    },
    commentFeedQuery: {
      id: 'commentFeed',
      fields: ['country', 'date', 'age', 'gender', 'language']
    }
  },
  MOVIE_PAGE_ID: 'movieReport',
  MOVIE_ANTICIPATION_PAGE_ID: 'movieReportAnticipation',
  MOVIE_VIEWERSHIP_PAGE_ID: 'movieReportViewership',
  MOVIE_ENGAGEMENT_PAGE_ID: 'movieReportEngagement',
  MOVIE_AFFINITY_PAGE_ID: 'movieReportAffinity',
  MOVIE_SUMMARY_PAGE_ID: 'movieSummaryReport',
  MOVIE_SUMMARY_FILTERS: movieSummaryReport
};

export default moviesConfig;
